// 签收人确认弹窗 — 确认签收人信息并上传签名
import { Button, Input, Modal, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

export default function SignerConfirmModal({
  open, loading, signers,
  onCancel, onOk,
  onFieldChange, onAddRow, onRemoveRow, onSignatureFile,
}) {
  return (
    <Modal title="确认签收人信息" open={open} onCancel={onCancel}
      onOk={onOk} okText="提交审核" width={680}
      confirmLoading={loading} destroyOnClose>
      <div style={{ marginBottom: 12, padding: '8px 12px', background: '#f6ffed', borderRadius: 6, border: '1px solid #b7eb8f', fontSize: 13 }}>
        请添加签收人信息并上传<strong>签名图片</strong>，完成后提交管理员审核。
      </div>
      {signers.map((s, i) => (
        <div key={s.key} style={{ marginBottom: 16, padding: 12, border: '1px solid #f0f0f0', borderRadius: 8, background: '#fafafa' }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
            <strong>签收人 {i + 1}</strong>
            {signers.length > 1 && (
              <Button type="link" danger size="small" onClick={() => onRemoveRow(s.key)}>移除</Button>
            )}
          </div>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 140px' }}>
              <div style={{ marginBottom: 4, fontSize: 12, color: '#888' }}>姓名</div>
              <Input value={s.name} onChange={e => onFieldChange(s.key, 'name', e.target.value)} placeholder="姓名" />
            </div>
            <div style={{ flex: '1 1 140px' }}>
              <div style={{ marginBottom: 4, fontSize: 12, color: '#888' }}>手机号</div>
              <Input value={s.phone} onChange={e => onFieldChange(s.key, 'phone', e.target.value)} placeholder="手机号" maxLength={11} />
            </div>
            <div style={{ flex: '1 1 160px' }}>
              <div style={{ marginBottom: 4, fontSize: 12, color: '#888' }}>身份证号</div>
              <Input value={s.id_card} onChange={e => onFieldChange(s.key, 'id_card', e.target.value)} placeholder="身份证号" maxLength={18} />
            </div>
            <div style={{ flex: '0 0 180px' }}>
              <div style={{ marginBottom: 4, fontSize: 12, color: '#888' }}>签名图片 <span style={{ color: 'red' }}>*</span></div>
              <Upload maxCount={1} beforeUpload={file => { onSignatureFile(s.key, file); return false; }} accept="image/*"
                showUploadList={{ showPreviewIcon: false, showRemoveIcon: s.signature_base64 ? true : false }}
                listType="picture" style={{ whiteSpace: 'nowrap' }}>
                <Button size="small" icon={<PlusOutlined />}>上传签名</Button>
              </Upload>
            </div>
          </div>
        </div>
      ))}
      <Button type="dashed" icon={<PlusOutlined />} onClick={onAddRow} block>
        手动添加签收人
      </Button>
    </Modal>
  );
}
